var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuduErro404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 609.87 584.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-27,.cls-28,.cls-34{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#6cf2af;}.cls-4{fill:#69efdf;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#5cc5a9;}.cls-7{fill:#e9e9e9;}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:#f3f3f3;}.cls-10{clip-path:url(#clip-path-3);}.cls-11,.cls-34{stroke:#fff;}.cls-11,.cls-27,.cls-28,.cls-34{stroke-linecap:round;stroke-linejoin:round;}.cls-11{stroke-width:1.45px;}.cls-12{mix-blend-mode:multiply;}.cls-13{clip-path:url(#clip-path-4);}.cls-14{clip-path:url(#clip-path-5);}.cls-15{fill:#eee;}.cls-16{fill:#808285;}.cls-17{clip-path:url(#clip-path-6);}.cls-18{fill:#5a5a64;}.cls-19{fill:#f2f2f2;}.cls-20{fill:#afc636;}.cls-21{fill:#32c832;}.cls-22,.cls-38,.cls-39{fill:#a0e114;}.cls-23{fill:#19eb82;}.cls-24{mix-blend-mode:overlay;opacity:0.3;}.cls-25{clip-path:url(#clip-path-7);}.cls-26{fill:#fff;}.cls-27,.cls-28{stroke:#808285;stroke-width:3.56px;}.cls-28{stroke-dasharray:0.19 7.65;}.cls-29{clip-path:url(#clip-path-8);}.cls-30{clip-path:url(#clip-path-9);}.cls-31{fill:#efefef;}.cls-32{clip-path:url(#clip-path-10);}.cls-33{clip-path:url(#clip-path-11);}.cls-34{stroke-width:1.24px;}.cls-35{clip-path:url(#clip-path-12);}.cls-36{clip-path:url(#clip-path-13);}.cls-37{clip-path:url(#clip-path-14);}.cls-38{opacity:0.24;}.cls-39{opacity:0.62;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.46,250.55A568,568,0,0,1,434,218.05c22.8-7.5,47.5-13.53,73.19-10.51,27.86,3.27,47,21,66.26,43.36,33.91,39.44,43.63,94.73,31.28,139.09s-44.17,78.46-82.18,101.25c-85.35,51.19-224.54,62-312.81-30.43-12.46-13.05-23.69-28.61-26.61-45.5-4.7-27.27,13.53-44,28.78-60.35,19.93-21.35,43-40.15,66.57-57.35A556.22,556.22,0,0,1,355.46,250.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.23,238.36,224.45,353.8c10.58,2.72,22-.85,31.18-6.5s16.65-13.23,25.05-19.8,16.41-13,29.22-13,20.81,6.44,29.21,13,15.91,14.16,25.06,19.8,20.59,9.22,31.18,6.5l40.36-115.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.15,454h0m-76.94-166.3c-10.75,24.61-10.2,53.84-4.76,80.61,3.66,18.06,9.54,35.79,19.27,50.65s24.33,34.79,63.18,35c38.84-.25,53.5-20.27,63.17-35s15.61-32.59,19.28-50.65c5.43-26.77,6-56-4.77-80.61-14.67-33.6-44.31-40.82-77.68-40.82s-63,7.22-77.69,40.82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 184.77,
    y: 214.82,
    width: 235.85,
    height: 300.38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.9,246.89c33.37,0,63,7.22,77.68,40.82,10.75,24.61,10.2,53.84,4.77,80.61-3.67,18.06-9.54,35.79-19.28,50.65s-24.51,35-63.92,35h1.49c-39.41,0-54.19-20.18-63.92-35s-15.61-32.59-19.27-50.65c-5.44-26.77-6-56,4.76-80.61,14.67-33.6,44.31-40.82,77.69-40.82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.48,214.69c-2,4.22-1.64,9.13-.94,13.73,1,6.4,2.69,12.81,6.14,18.29a26.58,26.58,0,0,0,16,11.5h.13a26.63,26.63,0,0,0,16-11.5c3.44-5.48,5.15-11.89,6.13-18.29.71-4.6,1-9.51-.94-13.73-1.47-3.17-11.36-4.75-21.25-4.75s-19.77,1.58-21.24,4.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 230.05,
    y: 43.84,
    width: 83.58,
    height: 193.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.67 519.03 290.3 521.65 310.62 483.72 295.99 481.1 275.67 519.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.27,321.93a64.4,64.4,0,0,1,7.66,20.67,87.86,87.86,0,0,1,21.69-6.36,53.55,53.55,0,0,0-7.49-24.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.57,338.77l28.31,34.7a30,30,0,0,1,33.57-5.77l4.13-48.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.41,333.73c-12.46,5.45-16,14.19-16,14.19,8.07,22.86,17.6,43.73,22.21,51.92,2.55,4.52,6.12,9.34,9.68,8.64,3.14-.63,4.53-5.29,5.27-9.6a220.67,220.67,0,0,0,.34-69.07s-9-1.54-21.5,3.92"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.92,322.66a64.18,64.18,0,0,0-8.81,20.21,88.1,88.1,0,0,0-21.3-7.58,53.58,53.58,0,0,1,8.85-23.84Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.64,340.58l-30.21,33.06a30,30,0,0,0-33.2-7.65l-1.39-48.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.14,333.53c12.14,6.14,15.18,15.07,15.18,15.07-9.35,22.37-20,42.67-25.09,50.59-2.8,4.37-6.64,9-10.15,8.08-3.1-.8-4.23-5.53-4.72-9.88a220.7,220.7,0,0,1,3.53-69s9.11-1,21.25,5.12"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.54,2.14c-53.33-5.36-108.2-1.08-158.41,17.69S58.61,72.49,30.79,118.3c-39,64.25-40,148.23-8.41,216.46s93.1,120.48,163.31,147.35,148.36,29.49,222.05,14.58c40-8.09,71.57-44.12,84.83-82.72,9.95-28.93,3.9-61.06-7.12-89.6s-26.8-55.09-37.16-83.87c-16.37-45.48-18.64-95-33.73-140.89S360.63,7,312.54,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.46,250.55A568,568,0,0,1,434,218.05c22.8-7.5,47.5-13.53,73.19-10.51,27.86,3.27,47,21,66.26,43.36,33.91,39.44,43.63,94.73,31.28,139.09s-44.17,78.46-82.18,101.25c-85.35,51.19-224.54,62-312.81-30.43-12.46-13.05-23.69-28.61-26.61-45.5-4.7-27.27,13.53-44,28.78-60.35,19.93-21.35,43-40.15,66.57-57.35A556.22,556.22,0,0,1,355.46,250.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M312.54,2.14c-53.33-5.36-108.2-1.08-158.41,17.69S58.61,72.49,30.79,118.3c-39,64.25-40,148.23-8.41,216.46s93.1,120.48,163.31,147.35,148.36,29.49,222.05,14.58c40-8.09,71.57-44.12,84.83-82.72,9.95-28.93,3.9-61.06-7.12-89.6s-26.8-55.09-37.16-83.87c-16.37-45.48-18.64-95-33.73-140.89S360.63,7,312.54,2.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M309.9,246.88c33.37,0,63,7.23,77.68,40.83,10.75,24.61,10.2,53.84,4.77,80.61-3.67,18.06-9.55,35.79-19.28,50.65s-24.51,35-63.92,35h1.49c-39.41,0-54.19-20.18-63.92-35s-15.61-32.59-19.27-50.65c-5.44-26.77-6-56,4.76-80.61,14.67-33.6,44.31-40.83,77.69-40.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M309.9,246.88c33.37,0,63,7.23,77.68,40.83,10.75,24.61,10.2,53.84,4.77,80.61-3.67,18.06-9.55,35.79-19.28,50.65s-24.51,35-63.92,35h1.49c-39.41,0-54.19-20.18-63.92-35s-15.61-32.59-19.27-50.65c-5.44-26.77-6-56,4.76-80.61,14.67-33.6,44.31-40.83,77.69-40.83"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.35,353.8c-10.59,2.72-22-.85-31.18-6.49s-16.66-13.24-25.06-19.81-16.41-13-29.21-13-20.82,6.44-29.22,13-15.91,14.16-25.05,19.81-20.59,9.21-31.18,6.49"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M248.88,252.47c37.22-1.89,94.1,19.69,112.46,52.12C375.13,329,378.23,358.42,373.63,386s-16.42,53.58-30.86,77.56c0,0,93.41-70.05,75.59-189.45s-169.48-21.68-169.48-21.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M286.59,422.41c-.79-1-1.59-1.91-2.4-2.83-3.69-4.22-13.09-13.57-19.78-10.7-11.84,5.08-9.69,30.38-7.88,45.47,2.54,21.15,8.56,42,18.76,61,2.11,3.92,5.16,8.15,9.36,8.62,4.75.52,8-4,10.08-8.26,7-14.53,14.74-34.79,12.49-51.1-2-14.8-10.83-30.26-20.63-42.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M345.31,414.64c.94-.83,1.88-1.64,2.82-2.41,4.32-3.58,15.1-11.3,21.24-7.4,10.88,6.9,4.71,31.54.51,46.14-5.9,20.47-15.18,40.11-28.28,57.2-2.71,3.54-6.4,7.23-10.62,7-4.77-.25-7.28-5.26-8.63-9.77-4.62-15.47-9-36.69-4.15-52.44,4.37-14.29,15.53-28.13,27.11-38.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M191,307.79c7-9.81,15-19.18,24.1-25.68s19.46-9.8,27-6.74c9.45,3.81,11.22,12.76,8.16,24.4-3.41,13-12.82,29.31-24.26,45.63,0,0-13.11,1.19-26.19-12.59s-8.84-25-8.84-25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M222.37,340.91a74.89,74.89,0,0,0-15.62,20.4,102.14,102.14,0,0,0-22-14.52,62.46,62.46,0,0,1,16.67-24.51Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M310.79,258.21a26.65,26.65,0,0,0,16-11.49c3.44-5.49,5.15-11.9,6.13-18.3.7-4.6,1-9.51-.94-13.73-2.93-6.33-39.56-6.33-42.49,0-2,4.22-1.64,9.13-.94,13.73,1,6.4,2.69,12.81,6.13,18.3a26.65,26.65,0,0,0,16,11.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M310.79,258.21a26.65,26.65,0,0,0,16-11.49c3.44-5.49,5.15-11.9,6.13-18.3.7-4.6,1-9.51-.94-13.73-2.93-6.33-39.56-6.33-42.49,0-2,4.22-1.64,9.13-.94,13.73,1,6.4,2.69,12.81,6.13,18.3a26.65,26.65,0,0,0,16,11.49"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M289.28,237.35c13.29,8.77,32.8,15.79,47.84,10.58l.5-25.92s-52.33-2.69-52.15-1.8,3.81,17.14,3.81,17.14"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M339.79,29.18c25.33,3.65,52.19,26.64,67.58,50.06,26.18,39.84,43.09,100.26,6.87,139.1a81.57,81.57,0,0,1-45.78,24.45c-19.44,3.27-39.42-2.2-58.68-5l-.17,0c-19.26-2.77-40-3.16-57.7-11.77a81.56,81.56,0,0,1-37-36.37C191.07,142.19,224.32,89,260.66,58.14c21.38-18.14,53.63-32.63,79-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M407.41,139.2c8.36,12.74,15,30.08,4.34,45.45C404.88,194.56,391,201,377.22,203s-38.29-.33-62.56-3.92l1,.15c-24.3-3.4-48.48-8-61.13-13.87s-24.17-15.88-28-27.32c-5.88-17.74,5.36-32.52,17-42.39,19.45-16.5,53-23.9,86.89-19.16,33.85,4.92,62.94,21.39,77,42.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M407.41,139.2c8.36,12.74,15,30.08,4.34,45.45C404.88,194.56,391,201,377.22,203s-38.29-.33-62.56-3.92l1,.15c-24.3-3.4-48.48-8-61.13-13.87s-24.17-15.88-28-27.32c-5.88-17.74,5.36-32.52,17-42.39,19.45-16.5,53-23.9,86.89-19.16,33.85,4.92,62.94,21.39,77,42.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M407.24,145.39c8,11.71,14.35,27.63,4.33,41.65-6.46,9-19.59,14.84-32.66,16.61s-36.32-.48-59.36-3.89l1,.14c-23.06-3.22-46-7.53-58-13s-23-14.66-26.65-25.15c-5.66-16.28,4.92-29.75,15.89-38.74,18.38-15,50.18-21.62,82.33-17.12,32.13,4.67,59.8,19.89,73.2,39.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M294.21,158.86a2.3,2.3,0,0,0-.23-.4c-1.11-1.45-3.38-.66-5.06.07A25.16,25.16,0,0,1,261.4,153a5.54,5.54,0,0,0-2.79-2c-5.74-1,.4,11.36,1.46,12.86,3,4.2,7.57,7.94,12.81,8.69,8.11,1.17,15.9-3.51,20.41-10,.76-1.08,1.42-2.55.92-3.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M341.63,165.68a2.51,2.51,0,0,1,.33-.32c1.47-1.08,3.43.32,4.83,1.49a25.15,25.15,0,0,0,28,2.44,5.61,5.61,0,0,1,3.24-1.13c5.79.68-3.58,10.8-5,11.93-4.06,3.19-9.51,5.48-14.74,4.73-8.11-1.17-14.27-7.85-16.77-15.34-.42-1.25-.65-2.84.16-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M354.15,67.91C353,75.62,343.32,80.6,332.45,79S313.66,70,314.76,62.24s10.83-12.69,21.7-11.12,18.8,9.08,17.69,16.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M336.46,51.11c10.88,1.57,18.8,9.09,17.69,16.8S343.32,80.6,332.45,79s-18.8-9.08-17.69-16.8,10.83-12.69,21.7-11.13m.42-2.86c-12.44-1.79-23.65,4.31-25,13.58S319.6,80.12,332,81.91s23.64-4.31,25-13.59S349.31,50,336.88,48.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M354.15,67.91C353,75.62,343.32,80.6,332.45,79S313.66,70,314.76,62.24s10.83-12.69,21.7-11.12S355.26,60.2,354.15,67.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M332,64.34l2.51-2.87A22.81,22.81,0,0,1,349.06,53s3-.08-.37,1.39-9.63,6.3-11.31,10.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.09,66.31l-8.19-1.18,3.8-4.35a23.84,23.84,0,0,1,15.19-8.87c1.49,0,2.26.34,2.44,1.13.28,1.23-1.21,1.89-2.2,2.33-3.38,1.49-9.24,6.17-10.73,10.12Zm-3.92-2.76,2.55.37c1.62-3.36,5.34-6.75,8.58-8.89a21.79,21.79,0,0,0-9.85,7l-.13.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "337.28 65.99 342.64 75.74 338.31 75.11 334.23 67.97 328.35 73.68 324.01 73.06 331.91 65.22 337.28 65.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M332,64.34l-5.36-9.75,4.34.62,3.53,6.26A22.81,22.81,0,0,1,349.06,53s3-.08-.37,1.39-9.63,6.3-11.31,10.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M311.58,56.56c1.57-3.36,3.17-7.52,1-10.52-7.94-10.92-37.43,22.1-42.36,27.73a161.34,161.34,0,0,0-36.78,139.88A81.73,81.73,0,0,0,251.91,226c16.16,7.85,34.79,8.87,52.55,11.08-21.57-57.92-19.11-124.53,7.12-180.55"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M336.32,219.06l-.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M329,216.71A134.38,134.38,0,0,0,294,211.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M290.19,211.87h-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M309.31,211.66a4.4,4.4,0,1,0,5-3.73,4.4,4.4,0,0,0-5,3.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M318.37,214.08a3.59,3.59,0,1,1,3,4.06,3.59,3.59,0,0,1-3-4.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M301.27,211.62a3.7,3.7,0,1,1,3.14,4.19,3.71,3.71,0,0,1-3.14-4.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M341,418.82c.85-.93,1.69-1.83,2.54-2.71,3.9-4,13.77-12.88,20.3-9.68,11.57,5.67,8.14,30.83,5.57,45.81-3.61,21-10.69,41.53-21.83,60-2.31,3.81-5.57,7.88-9.79,8.13-4.77.28-7.82-4.43-9.65-8.75-6.29-14.88-13-35.5-9.88-51.68,2.78-14.68,12.35-29.66,22.74-41.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M282.66,418.49c-.81-.95-1.64-1.88-2.46-2.78-3.78-4.14-13.37-13.29-20-10.29-11.73,5.32-9.06,30.58-6.93,45.62,3,21.1,9.43,41.84,20,60.59,2.19,3.88,5.33,8,9.53,8.42,4.77.43,8-4.19,9.92-8.46,6.73-14.68,14-35.08,11.42-51.35-2.34-14.76-11.46-30-21.5-41.75"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M276.2,515.8c1.62,2.18,3.63,3.9,6.12,4.3,4.72.76,8.23-3.62,10.49-7.74,4.42-8.07,6.92-17.8,9.9-27.87,0,0-12.34,24-17,27.49-5.88,4.45-9.5,3.82-9.5,3.82"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M372.27,321.93a64.31,64.31,0,0,1,7.66,20.67,87.86,87.86,0,0,1,21.69-6.36,53.55,53.55,0,0,0-7.49-24.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M370.4,325.83a46,46,0,0,0,33.18-.22s.35-20.21-12.65-28.14-20.53,28.36-20.53,28.36"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M403.75,304.76c-3-9.91-6.86-19.73-12.44-27.53s-13.08-13.35-20.08-13c-8.72.47-12.64,7.24-13.39,17.54-.83,11.48,2.27,27.35,7,43.78,0,0,10.32,4.6,24.76-2.95s14.12-17.87,14.12-17.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M409.91,329.81a220.67,220.67,0,0,1-.34,69.07c-.74,4.31-2.13,9-5.27,9.6-3.56.7-7.13-4.12-9.68-8.64-4.61-8.19-14.13-29.06-22.21-51.92,0,0,3.54-8.74,16-14.2s21.5-3.91,21.5-3.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M409.91,329.81a220.67,220.67,0,0,1-.34,69.07c-.74,4.31-2.13,9-5.27,9.6-3.56.7-7.13-4.12-9.68-8.64-4.61-8.19-14.13-29.06-22.21-51.92,0,0,3.54-8.74,16-14.2s21.5-3.91,21.5-3.91"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M414.45,367.7a30,30,0,0,0-33.57,5.77"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M240.92,322.66a64.18,64.18,0,0,0-8.81,20.21,88.1,88.1,0,0,0-21.3-7.58,53.58,53.58,0,0,1,8.85-23.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M242.57,326.65a45.91,45.91,0,0,1-33.12-2.08s.79-20.19,14.21-27.38,18.91,29.46,18.91,29.46"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M210.45,303.75c3.54-9.73,8-19.32,14-26.79s13.8-12.6,20.77-11.82c8.69,1,12.22,7.94,12.39,18.26.18,11.51-3.81,27.18-9.48,43.31,0,0-10.56,4-24.55-4.33s-13.1-18.63-13.1-18.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M202.89,328.41a220.7,220.7,0,0,0-3.53,69c.49,4.35,1.62,9.08,4.72,9.88,3.51.91,7.35-3.71,10.15-8.08C219.3,391.27,230,371,239.32,348.6c0,0-3-8.93-15.18-15.07s-21.25-5.12-21.25-5.12"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M202.89,328.41a220.7,220.7,0,0,0-3.53,69c.49,4.35,1.62,9.08,4.72,9.88,3.51.91,7.35-3.71,10.15-8.08C219.3,391.27,230,371,239.32,348.6c0,0-3-8.93-15.18-15.07s-21.25-5.12-21.25-5.12"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M196.24,366a29.94,29.94,0,0,1,33.19,7.65"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 309.9,
    cy: 568.12,
    rx: 66.08,
    ry: 16.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 309.9,
    cy: 565.79,
    rx: 46.41,
    ry: 11.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 309.9,
    cy: 563.45,
    rx: 26.75,
    ry: 6.69
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuduErro404);
export default __webpack_public_path__ + "static/media/dudu_erro_404.5873282667088458d6baaf8af0d11301.svg";
export { ForwardRef as ReactComponent };